import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useAbility } from '@casl/react';
import { indexEmployeesRequest } from '../../../requests/employees';
import ShowButtonBlack from '../../HRDashboardStyled/images/ShowButtonBlack.png';
import { AbilityContext } from '../../../config/abilityContext';
import BirthsSideModal from './BirthsSideModal';

const BirthCalendar = () => {
  const dispatch = useDispatch();
  const ability = useAbility(AbilityContext);
  const [todayBirths, setTodayBirths] = useState('');
  const [panelShow, setPanelShow] = useState(false);
  const [showSpinner, setShowSpinner] = useState(1);
  const [showPanelSpinner, setShowPanelSpinner] = useState(false);
  const [panelBirths, setPanelBirths] = useState([]);
  const [panelMonth, setPanelMonth] = useState(moment().startOf('month'));
  const currentMonth = panelMonth.locale('es').format('MMMM');
  const currentMonthCapitalized = currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1);
  const currentYear = panelMonth.year();
  const canIndexEmployees = ability.can('index', 'Employee');

  const handleShowInfo = () => {
    setPanelShow(true);
  };

  const handlePrevMonth = () =>
    setPanelMonth(prev => {
      const current = moment(prev);
      if (current.month() === 0) {
        return moment()
          .year(moment().year())
          .month(11)
          .startOf('month');
      }
      return current.subtract(1, 'months');
    });

  const handleNextMonth = () =>
    setPanelMonth(prev => {
      const current = moment(prev);
      if (current.month() === 11) {
        return moment()
          .year(moment().year())
          .month(0)
          .startOf('month');
      }
      return current.add(1, 'months');
    });

  const handleCurrentMonth = () => setPanelMonth(moment().startOf('month'));

  const handleSuccessEmployees = response => {
    const results = response.data.data;
    const dayMonthToday = moment().format('DD-MM');
    const births = results.filter(item => moment(item.birthdate).format('DD-MM') === dayMonthToday);
    setTodayBirths(births.slice(0, 2));
    setShowSpinner(0);
  };

  const handleSuccessPanelEmployees = response => {
    const results = response.data.data;
    setPanelBirths(results);
    setShowPanelSpinner(false);
  };

  const fetchEmployees = () => {
    if (!canIndexEmployees) {
      setShowSpinner(0);
      return;
    }

    const thisMoment = moment().format('YYYY-MM-DD');
    const endOfMonth = moment(thisMoment)
      .endOf('month')
      .toString();
    const startOfMonth = moment(thisMoment)
      .startOf('month')
      .toString();

    indexEmployeesRequest({
      dispatch,
      params: {
        paginate: false,
        active: true,
        birthdate_from: startOfMonth,
        birthdate_to: endOfMonth
      },
      successCallback: handleSuccessEmployees,
      failureCallback: () => setShowSpinner(0)
    });
  };

  const fetchPanelEmployees = () => {
    if (!canIndexEmployees) return;

    setShowPanelSpinner(true);
    const thisMoment = moment(panelMonth).format('YYYY-MM-DD');
    const endOfMonth = moment(thisMoment)
      .endOf('month')
      .toString();
    const startOfMonth = moment(thisMoment)
      .startOf('month')
      .toString();

    indexEmployeesRequest({
      dispatch,
      params: {
        paginate: false,
        active: true,
        birthdate_from: startOfMonth,
        birthdate_to: endOfMonth,
        sort: 'birthdate'
      },
      successCallback: handleSuccessPanelEmployees,
      failureCallback: () => setShowPanelSpinner(false)
    });
  };

  useEffect(fetchEmployees, []);
  useEffect(fetchPanelEmployees, [panelMonth, panelShow]);

  return (
    <>
      <div
        id="HRDashboard"
        style={{
          backgroundColor: '#fff',
          border: '1px solid #E0E0E0',
          borderRadius: '8px',
          height: '100%',
          minHeight: '121px'
        }}
      >
        <div
          style={{
            textAlign: 'center',
            backgroundColor: '#fff',
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8
          }}
        >
          <Row>
            <Col className="mt-2" md={8} xl={8} xs={8}>
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#827f7f',
                  textAlign: 'left',
                  marginLeft: '10px'
                }}
              >
                Cumpleaños
              </p>
            </Col>
            {!showSpinner && canIndexEmployees && (
              <Col md={4} xl={4} xs={4} style={{ paddingRight: '30px' }}>
                <div className="DownloadButton">
                  <button type="button" onClick={handleShowInfo} style={{ backgroundColor: '#fff' }}>
                    <img src={ShowButtonBlack} alt="DownloadButtonImage.png" />
                  </button>
                </div>
              </Col>
            )}
          </Row>
        </div>

        <div style={{ paddingRight: 15, paddingLeft: 15 }}>
          <Row className="align-items-center">
            {showSpinner ? (
              <Col className="div-content mt-3 mb-2">
                <div className="containerSpinnerLoadDash" style={{ position: 'absolute', height: '100%' }}>
                  <Spinner animation="border" variant="primary" />
                </div>
              </Col>
            ) : (
              <>
                <Col sm={12} md={12} xs={12} className="mb-2">
                  Cumpleañeros de Hoy
                </Col>
                {todayBirths.length > 0 ? (
                  todayBirths.map(item => (
                    <Col key={item.id} className="col-sm-12 ml-2">
                      <p className="mb-1">{item.short_name}</p>
                    </Col>
                  ))
                ) : (
                  <p className="ml-4 mb-8">Sin cumpleañeros hoy...</p>
                )}
              </>
            )}
          </Row>
        </div>
      </div>

      {panelShow && (
        <BirthsSideModal
          show={panelShow}
          onHide={() => setPanelShow(false)}
          data={panelBirths}
          title={`Cumpleaños: ${currentMonthCapitalized} ${currentYear}`}
          showMonthControls
          onPrevMonth={handlePrevMonth}
          onNextMonth={handleNextMonth}
          onCurrentMonth={handleCurrentMonth}
          showPanelSpinner={showPanelSpinner}
        />
      )}
    </>
  );
};

export default BirthCalendar;
